jQuery(document).ready(function() {
        jQuery('.bt_top').on('click', function (event) {
            jQuery('body, html').stop().animate({scrollTop: 0}, 800);
            event.preventDefault();
        });

        window.AOS && AOS.init({
            once:true,
            mirror:false,
            disable: function() {
                var maxWidth = 800;
                return window.innerWidth < maxWidth;
            }
        });

        var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        if (viewportWidth > 640) {
        } else {
            jQuery('.logo-res__rs').insertAfter('div.menu-bottom>div:first-child');
            jQuery('footer .menu-bottom>li>ul').hide();
            jQuery('footer .menu-bottom>li>a').click(function() {
                event.preventDefault();
                jQuery(this).next('ul').toggle();
                jQuery(this).parent().toggleClass('active');


            });
        }
            
     });
     $(window).resize(function() {
        var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
            if (viewportWidth < 640) {
                jQuery('.logo-res__rs').insertAfter('div.menu-bottom>div:first-child');
            jQuery('footer .menu-bottom>li>ul').hide();
            jQuery('footer .menu-bottom>li>a').click(function() {
                event.preventDefault();
                jQuery(this).next('ul').toggle();
                jQuery(this).parent().toggleClass('active');

            });
            } else {
                jQuery('.logo-res__rs').insertAfter('.logo-res__logo');
                jQuery('footer .menu-bottom>li>ul').show();
            }

        });
